<template>
	<div>
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100 md-small-size-100 md-xsmall-size-100">
				<div class="system-info">
					<div class="system-container">
						<div class="system-ministry">
							<img src="/logo.png" class="ministry-logo">
							<p class="ministry-khmer">ក្រសួងឧស្សាហកម្ម វិទ្យាសាស្ត្រ បច្ចេកវិទ្យា និងនវានុវត្តន៍
							</p>
							<p class="ministry-english">Ministry of Industry, Science, Technology & Innovation
							</p>
						</div>
						<div class="system-title">{{translate(locale.headTitle)}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {

			
		},
		data() {
			return {
			}
		},
		methods: {
		}
	}
</script>

<style scoped>

	.system-info {
		overflow: hidden;
		position: relative;
		margin: 0 -15px;
	}

	.system-container {
		background-image: url("/single_id.jpg");
		background-size: cover;
		background-position: center bottom;
		background-color: #00CCFF;
		background-repeat: no-repeat;
		min-height: 100vh;
		background-attachment: scroll;
		padding: 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.system-title {
		font-family: "Open Sans", "Kantumruy Pro", sans-serif;
		text-align: center;
		color: #FFF;
		font-weight: 700;
		margin-top: 50px;
		margin-bottom: 100px;
		font-size: 26px;
	}

	.system-ministry {
		text-align: center;
	}

	.system-ministry p {
		color: #FFF;
		font-weight: 700;
		font-family: "Open Sans", "Kantumruy Pro", sans-serif;
	}

	.ministry-khmer {
		font-size: 18px;
	}

	.ministry-logo {
		margin-bottom: 20px;
		width: 100px;
	}

	@media (max-width: 1264px) {
		.method-text {
			font-size: 12px;
		}

		.system-container {
			padding: 20px;
		}

		.system-title {
			font-size: 20px;
			margin-top: 20px;
			margin-bottom: 20px;
		}

		.system-ministry p {
			color: #FFF;
			font-weight: 700;
			font-size: 12px;
			font-family: "Open Sans", "Kantumruy Pro", sans-serif;
		}

		.ministry-khmer {
			font-size: 14px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/404.vue